import { Dialog, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useImperativeHandle, useState } from "react";

import DialogBody from "../../../components/dialog/DialogBody";
import DialogHeader from "../../../components/dialog/DialogHeader";
import InputField from "../../../components/InputField";
import Label from "../../../components/label";
import DialogActionButtons from "../../../components/dialog/DialogActions";
import { useSelector } from "react-redux";
import { updateUserBackDetail } from "../../../services/userDetailFn";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import AppLoader from "../../../components/apploader";
import { updateBankAccountValidation } from "../../../utils/validation";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = {};

const AttachBankDialog = forwardRef(({}, ref) => {
  const { showSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState({
    accountHolderName: "",
    iban: "",
    bankName: "",
  });
  const [inputError, setInputError] = useState({
    accountHolderName: false,
    iban: false,
    isValidIban: false,
    bankName: false,
  });
  const userData = useSelector((state) => state.userReducer.user);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
      if (params?.type === "edit") {
        setInputValues({
          accountHolderName: params?.data?.accountHolderName || "",
          iban: params?.data?.iban || "",
          bankName: params?.data?.bankName || "",
        });
      }
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setInputValues({
      accountHolderName: "",
      iban: "",
      bankName: "",
    });
    setInputError({
      accountHolderName: false,
      iban: false,
      isValidIban: false,
      bankName: false,
    });
  };

  const handleChanegeInputValues = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    setInputError((prev) => ({
      ...prev,
      [name]: value.trim() === "",
    }));
  };

  const handleUpdateBankDetails = async () => {
    const validate = updateBankAccountValidation(inputValues, setInputError);

    if (validate) return;

    try {
      const paylaod = {
        ...inputValues,
        userId: userData?._id,
      };
      setIsLoading(true);
      const response = await updateUserBackDetail(paylaod);
      if (response.data.status === "success") {
        paramsData?.getDetails();
        handleClose();
        showSnackbar(response.data.message, "success");
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error updating bank details:", error);
      showSnackbar(t("failedToUpdateBankDetails"), "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogHeader
          title={t("bankDetails")}
          secondaryHeading={t("attachYourBankDetails")}
          onClose={handleClose}
        />
        <DialogBody>
          <Grid container>
            <Grid item xs={12}>
              <Label text={t("accountHolderName")} htmlFor="account-holder" />
              <InputField
                id={"account-holder"}
                type="text"
                placeholder={`${t("enter")} ${t("accountHolderName")}`}
                value={inputValues.accountHolderName}
                name={"accountHolderName"}
                onChange={handleChanegeInputValues}
                inputError={inputError.accountHolderName}
                helperText={
                  inputError.accountHolderName && t("accountHolderNameRequired")
                }
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <Label text={"IBAN"} htmlFor="iban" />
              <InputField
                id={"iban"}
                type="text"
                placeholder={`${t("enter")} IBAN`}
                value={inputValues.iban}
                name={"iban"}
                onChange={handleChanegeInputValues}
                inputError={inputError.iban}
                helperText={
                  inputError.iban
                    ? t("ibanRequired")
                    : inputError.isValidIban
                    ? t("wrongIban")
                    : null
                }
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <Label text={t("bankName")} htmlFor="bank-name" />
              <InputField
                id={"bank-name"}
                type="text"
                placeholder={`${t("enter")} ${t("bankName")}`}
                value={inputValues.bankName}
                name={"bankName"}
                onChange={handleChanegeInputValues}
                inputError={inputError.bankName}
                helperText={inputError.bankName && t("bankNameRequired")}
              />
            </Grid>
          </Grid>
        </DialogBody>
        <DialogActionButtons
          onCancel={handleClose}
          onConfirm={handleUpdateBankDetails}
        />
      </BootstrapDialog>
    </>
  );
});

export default AttachBankDialog;
